<div class="container">
    <div class="row no-gutters">
        <div class="col-12">
            <div class="d-flex popup-head align-items-center">
                <div class="popup-title mr-auto" translate>lblAddAutoKey</div>
                <div class="float-right">
                    <a class="close mr-3" (click)="OnClose()" translate>
                        <span class="" aria-hidden="true">&times;</span>
                    </a>
                </div>
            </div>
            <div class=" scrollbar">


                <div class="card-body p-0">
                    <div class="row">
                        <div class="col-3">
                            <div class="flmid">
                                <div class="flgrow">
                                    <ng-container *ngIf="dealerList && dealerList.length > 0">
                                        <app-dealer-searchbox-dropdown [dealerList]="dealerList" [selectedDealer]="dealerSelected" ngDefaultControl name="dealerDropdown" (onSelectDealer)="onDealerSelected($event)">
                                        </app-dealer-searchbox-dropdown>
                                    </ng-container>
                                </div>
                            </div>
                        </div>
                    </div>
                    <ng-container *ngIf="keyLockerDetails?.length>0; else load_else">
                        <ul class="form-row fix-comment w-100 my-4">
                            <li class="col-md-4 col-lg-3 col-xl-2 text-center mb-3" *ngFor="let locker of keyLockerDetails; let i = index">
                                <a class="grey40 rounded-lg p-3 d-block cursor font-weight-bold" (click)="openLocker(mymodal, locker)">
                                  {{ locker.location }}\{{locker.lockerNo}}
                                </a>
                            </li>
                        </ul>
                    </ng-container>
                    <ng-template #load_else>
                        <div class="no-record p-3 text-center" translate>lblNoRecordsFound</div>
                    </ng-template>
                </div>
            </div>
            <div class="p-3 bg-light pp-footer-top-brdr">
                <div class="row">
                    <div _ngcontent-suh-c228="" class="col-12 d-flex flex-sm-row flex-column justify-content-end">
                        <a (click)="OnClose()" class="btn btn-secondary  btn-lg" translate>
                            <em class="fa fa-arrow-circle-left font16 align-top mr-2"></em> lblBack</a>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>



<ng-template #mymodal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title" translate>lblAssignlocker</h4>
        <button type="button" #closeModal id="modelButton" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">×</span>
    </button>
    </div>
    <div class="modal-body">
        <ul ngbNav #nav="ngbNav" class="nav-tabs bg-grey">
                <li class="nav-item">
                    <ng-container>
                        <a translate (click)="selectedtab=1" [ngClass]="{'active': selectedtab===1}" class="nav-link" translate>lblAssignWorkOrder</a>
                    </ng-container>
                </li>
        </ul>
        <ng-cotainer *ngIf="selectedtab===1">
            <app-with-work-order (selectedAppointmentDetails)="setSelectedAppointmentDetails($event)" [currentDealerId] = "selectedDealerId"></app-with-work-order>
        </ng-cotainer>
    </div>
    <div class="modal-footer">
        <div class="row">
            <div class="col-12 d-flex flex-sm-row flex-column justify-content-end">
                <button type="submit" class="btn btn-primary mr-sm-2" [disabled]="!appointmentId" (click)="AssignLocker()" translate aria-label="Center Align"><em class="far fa-save font16 align-top mr-2"></em>lblSaveChanges</button>
                <button (click)="modal.dismiss('Cross click')" class="btn btn-secondary" translate aria-label="Center Align"><em class="far fa-times-circle font16 align-top mr-2"></em>lblCancel</button>
            </div>
        </div>
    </div>

</ng-template>
